import {
  INICIALITZAR,
  INDRET_INICIALITZAR,
  OBTENIR_DADES_INDRET,
  ESBORRAR_INDRET_SELECCIONAT
} from "../../../actions/actionTypes";

const ESTAT_INICIAL = {
  id: null,
  nom: null,
  paisatge: null,
  clima: null,
  distanciaMar: null,
  relleu: null,
  orientacio: null,
  descripcio: null,
  motiuBaixa: null,
  dataBaixa: null,
  canvis: null,
  idObservador: null,
  nomObservador: null,
  fotos: null
};

const originals = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INDRET_INICIALITZAR:
    case INICIALITZAR:
    case `${OBTENIR_DADES_INDRET}_EN_CURS`:
    case `${OBTENIR_DADES_INDRET}_ERROR`:
    case ESBORRAR_INDRET_SELECCIONAT:
      return ESTAT_INICIAL;

    case `${OBTENIR_DADES_INDRET}_SUCCESS`:
      return action.payload.indret[0];

    default:
      return state;
  }
};

export default originals;
